module.exports = __webpack_public_path__ + "img/Inflammation-GBM_GSE194329.d7925f33.png";